<template>
    <v-card>
        <v-toolbar dense height="36px" v-if="advanced_view">
            <v-toolbar-title class="subtitle-2">
                {{job_details_obj.name}} - {{job_details_obj._id}}
            </v-toolbar-title>
        </v-toolbar>
        <v-toolbar dense height="36px" v-else>
            <v-toolbar-title class="subtitle-1 font-weight-medium">Job Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon x-small @click="close_job_details_dialog">
            <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0" v-if="job_details_obj">
            <template v-if="!show_task_log">
                <v-container fluid class="hidden-sm-and-down pa-0" style="font-size:.7em">
                    <v-row no-gutters v-if="advanced_view">
                        <v-flex lg3 class="px-1 text-center">
                            <div class="caption grey--text text--lighten-1 font-weight-bold">Tasks/Done/Failed</div>
                            <div class="white--text">
                                {{job_details_obj.tasks_total}}/{{job_details_obj.tasks_completed}}/{{job_details_obj.tasks_failed}}
                            </div>
                        </v-flex>
                        <v-flex lg2 class="px-1 text-center">
                            <div class="caption grey--text text--lighten-1 font-weight-bold">Average Task Time</div>
                            <div class="white--text">
                                {{job_details_obj.tasks_completed_duration_avg}}
                            </div>
                        </v-flex>
                        <v-flex lg7>
                            <v-layout>
                                <v-flex lg4 class="px-2">
                                    <div class="caption grey--text text--lighten-1 font-weight-bold">Requested</div>
                                    <div class="white--text">{{ (job_details_obj.created && to_local_datetime(job_details_obj.created)) || "-" }}</div>
                                </v-flex>
                                <v-flex lg4 class="px-2">
                                    <div class="caption grey--text text--lighten-1 font-weight-bold">Started</div>
                                    <div class="white--text">{{ (job_details_obj.start && to_local_datetime(job_details_obj.start)) || "-" }}</div>
                                </v-flex>
                                <v-flex lg4 class="px-2">
                                    <div class="caption grey--text text--lighten-1 font-weight-bold">Ended</div>
                                    <div class="white--text">{{ (job_details_obj.end && to_local_datetime(job_details_obj.end)) || "-" }}</div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-row>
                    <v-row no-gutters v-else>
                        <v-flex lg3>
                            <v-layout>
                                <v-flex lg7 class="px-2">
                                    <div class="caption grey--text">Job Name/ID</div>
                                    <div class="white--text font-weight-bold">
                                    {{job_details_obj.name}}<br/>
                                    <span class="job_id font-weight-regular">{{job_details_obj._id}}</span>
                                    </div>
                                </v-flex>
                                <v-flex lg5 class="px-2">
                                    <div class="caption grey--text text-center">Status</div>
                                    <div class="white--text text-center">
                                    <v-chip @click="x=false" :class="`status mx-0 ${job_details_obj.status}`" x-small text-color="white" :title="job_details_obj.status_message">
                                        {{job_details_obj.status}}
                                        <v-icon v-if="job_details_obj.status_message && job_details_obj.status_message != ''" right x-small color="warning">info</v-icon>
                                    </v-chip>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex lg1 class="px-2">
                            <div class="caption grey--text">Application</div>
                            <div class="white--text">
                                {{job_details_obj.product_name}}
                            </div>
                        </v-flex>
                        <v-flex lg2>
                            <v-layout>
                                <v-flex lg4 class="px-1 text-center">
                                    <div class="caption grey--text">Machine Type</div>
                                    <div class="white--text">{{job_details_obj.machine_type}}</div>
                                </v-flex>
                                <v-flex lg8 class="px-1 text-center">
                                    <div class="caption grey--text">Tasks/Done/Failed<br/>Average Task Time</div>
                                    <div class="white--text">
                                        {{job_details_obj.tasks_total}}/{{job_details_obj.tasks_completed}}/{{job_details_obj.tasks_failed}}
                                        <br/>
                                        {{job_details_obj.tasks_completed_duration_avg}}
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex lg1 class="px-2">
                            <div class="caption grey--text">Requested</div>
                            <div class="white--text">{{ (job_details_obj.created && to_local_datetime(job_details_obj.created)) || "-" }}</div>
                        </v-flex>
                        <v-flex lg1 class="px-2">
                            <div class="caption grey--text">Started</div>
                            <div class="white--text">{{ (job_details_obj.start && to_local_datetime(job_details_obj.start)) || "-" }}</div>
                        </v-flex>
                        <v-flex lg1 class="pl-4">
                            <div class="caption grey--text">Progress</div>
                            <div class="white--text">
                                <div v-if="job_details_obj.tasks_total == 1 && job_details_obj.status != 'Starting'">
                                    See log
                                </div>
                                <div v-if="job_details_obj.tasks_total > 1 && job_details_obj.status != 'Starting'">
                                    <v-progress-circular :rotate="-90" :size="32" :width="3" :value="job_details_obj.progress_percentage" :class="`${job_details_obj.status}`">
                                        {{job_details_obj.progress_percentage}}%
                                    </v-progress-circular>
                                </div>
                                <div v-if="job_details_obj.status == 'Starting'">
                                    <v-progress-circular :rotate="-90" :size="32" :width="3" :value="job_details_obj.sync_progress_percentage" :class="`${job_details_obj.status}`">
                                        {{job_details_obj.sync_progress_percentage}}%
                                    </v-progress-circular>
                                    Synching
                                </div>
                            </div>
                        </v-flex>
                        <v-flex lg1 class="px-2">
                            <div class="caption grey--text">Ended</div>
                            <div class="white--text">{{ (job_details_obj.end && to_local_datetime(job_details_obj.end)) || "-" }}</div>
                        </v-flex>
                        <v-flex lg2 class="px-2">
                            <v-layout>
                                <v-flex lg4 class="text-right">
                                    <div class="caption grey--text">Duration</div>
                                    <div class="white--text">
                                        {{job_details_obj.duration}}
                                        <div v-if="job_details_obj.status == 'Running' && job_details_obj.tasks_completed > 0">
                                            <v-chip color="primary" x-small>{{job_details_obj.duration_estimate}}</v-chip>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex lg4 class="px-1 text-right">
                                    <div class="caption grey--text">Credits</div>
                                    <div class="white--text">
                                        {{job_details_obj.credits_consumed && job_details_obj.credits_consumed.toFixed(2)}}
                                        <div v-if="job_details_obj.status == 'Running' && job_details_obj.tasks_completed > 0">
                                            <v-chip color="primary" x-small>{{job_details_obj.credits_estimate.toFixed(2)}}</v-chip>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex lg-4>
                                    <div class="caption grey--text">&nbsp;</div>
                                    <div class="white--text justify-center layout">
                                        <v-btn
                                            v-if="force_start_job_whitelist.indexOf(job_details_obj.status) > -1"
                                            fab dark height="18px" width="18px" x-small color="green" title="Force Start Job"
                                            @click.stop="force_start_job(job_details_obj);"
                                        >
                                            <v-icon x-small>play_circle_outline</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="restart_job_whitelist.indexOf(job_details_obj.status) > -1"
                                            fab dark height="18px" width="18px" x-small color="green" class="ml-1" title="Restart all or specific tasks"
                                            @click.stop="restart_job(job_details_obj);"
                                        >
                                            <v-icon x-small>refresh</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="stop_job_whitelist.indexOf(job_details_obj.status) > -1"
                                            fab dark height="18px" width="18px" x-small color="error" class="ml-1"
                                            @click.stop="stop_job(job_details_obj);"
                                        >
                                            <v-icon x-small>remove_circle_outline</v-icon>
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-row>
                    <v-row no-gutters v-if="advanced_view">
                        <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-flex lg12>
                            <v-data-table
                            :headers="task_headers"
                            :items="task_items"
                            class="elevation-1"
                            :loading="tasks_loading"
                            :options.sync="task_pagination"
                            dense
                            :footer-props="{
                                'items-per-page-options': [50, 100, 150, 200, 250]
                            }"
                            >
                                <template slot="no-data">
                                    Waiting to start
                                </template>

                                <template slot="loading">
                                    Loading...
                                </template>

                                <template v-slot:item.status="{ item }">
                                    <v-chip x-small :class="`status mx-0 ${item.status}`">{{item.status}}</v-chip>
                                </template>

                                <template v-slot:item.ram="{ item }">
                                    {{ item.ram || "-"}}
                                </template>

                                <template v-slot:item.start="{ item }">
                                    {{ item.start && to_local_datetime(item.start) }}
                                </template>

                                <template v-slot:item.end="{ item }">
                                    {{ item.end && to_local_datetime(item.end) }}
                                </template>

                                <template v-slot:item.duration_mins="{ item }">
                                    {{ item.duration }}
                                </template>

                                <template v-slot:item.credits_consumed="{ item }">
                                    {{ item.credits_consumed && item.credits_consumed.toFixed(2)}}
                                </template>

                                <template v-slot:item.actions="{ item }">
                                    <v-btn depressed x-small color="green" title="Show log" @click="getTaskLogs(item)">
                                        Log
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-row>
                </v-container>
                <v-container fluid class="hidden-md-and-up pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-dialog v-model="tasks_loading" persistent width="300">
                                <v-card color="primary" dark>
                                    <v-card-text>
                                        Loading...
                                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                            <v-card flat>
                                <v-card-subtitle>
                                    <strong>{{job_details_obj.name}}</strong> <br/> {{job_details_obj._id}}
                                </v-card-subtitle>
                            </v-card>
                            <v-list subheader two-line class="mb-8">
                                <template v-for="(task, index) in task_items">
                                    <v-list-item
                                        :key="`${task.name}_${index}`"
                                    >
                                        <v-list-item-content class="pa-0 my-1">
                                            <v-list-item-title>
                                                <v-chip small>
                                                    {{task.name}}
                                                </v-chip>
                                                <v-chip small :class="`status ml-1 ${task.status}`">{{task.status}}</v-chip>
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                <v-icon small class="blue--text">mdi-clock</v-icon> - {{ task.duration || "-" }}
                                                <v-icon small class="blue--text ml-2">mdi-currency-usd</v-icon> - {{ task.credits_consumed && task.credits_consumed.toFixed(2)}}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn depressed x-small color="green" title="Show log" @click="getTaskLogs(task)">
                                                Log
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider
                                        v-if="index < task_items.length - 1"
                                        :key="index"
                                    ></v-divider>
                                </template>
                            </v-list>

                            <v-footer app padless>
                                <div class="text-center flex-grow-1">
                                <v-pagination
                                    v-model="page"
                                    :length="page_length"
                                    :total-visible="total_visible"
                                    @input="load_page"
                                ></v-pagination>
                                </div>
                            </v-footer>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-if="show_task_log">
            <v-dialog v-model="log_loading" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                <v-card-text>
                    Retrieving log...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
                </v-card>
            </v-dialog>
            <v-container fluid class="pa-0 pb-2">
                <v-row no-gutters>
                <v-col cols="6" class="pt-2 pl-2 font-weight-bold caption">
                    <span class="info--text">All times are in UTC</span>
                </v-col>
                <v-col cols="6" class="pt-2 text-right">
                    <v-btn v-if="show_task_log" x-small @click="getTaskLogs(selected_task)" class="success text-capitalize caption">
                        Refresh
                    </v-btn>
                    <v-btn right v-if="show_task_log" x-small @click="hide_task_logs" @keydown.esc="hide_task_logs" class="error text-capitalize mx-2 caption">
                        Cancel
                    </v-btn>
                </v-col>
                </v-row>
                <v-row no-gutters>
                <v-col cols="12" class="px-2 body-2">
                    <v-btn v-if="task_log && task_log.has_redshift_log && !task_log_html" x-small @click="_getRedshiftLogs" class="warning text-capitalize">
                        View Redshift Logs
                    </v-btn>
                    <v-btn v-if="task_log_html" x-small @click="_getAppLogs" class="warning text-capitalize">
                        View App Logs
                    </v-btn>
                </v-col>
                <v-col cols="12" class="px-2 body-2">
                    <v-card light v-if="task_log_html" class="task_log d-flex px-2 mt-2" outlined :height="avail_height">
                        <iframe 
                            ref="redshift_iframe" width="100%" height="100%" style="border:none" 
                            @load="_populate_task_logs_iframe" 
                        />
                    </v-card>
                    <v-card v-if="!task_log_html" class="task_log d-flex px-2 mt-2" outlined>
                        <div style="font-size:.75em"><pre>{{(task_log && task_log.log)}}</pre></div>
                    </v-card>
                </v-col>
                </v-row>
            </v-container>
            </template>
        </v-card-text>
    </v-card>
</template>
<script>
import axios from 'axios';

export default {
    name: 'JobDetails',
    props: {
        advanced_view: {
            type: Boolean,
        },
        job_details_obj: {
            type: Object
        },
        force_start_job_whitelist: {
            type: Array
        },
        restart_job_whitelist: {
            type: Array
        },
        stop_job_whitelist: {
            type: Array
        },
        update_job_details_obj: {
            type: Function
        },
        close_job_details_dialog: {
            type: Function
        },
        force_start_job: {
            type: Function
        },
        restart_job: {
            type: Function
        },
        stop_job: {
            type: Function
        },
        refresh_parent: {
            type: Function
        },
        to_local_datetime: {
            type: Function
        },
    },
    data() {
        return {
            page: 1,
            page_length: 1,
            total_visible: 50,
            mobile_view: false,
            current_job_details_obj: null,
            avail_height: "520px",
            tasks_loading: false,
            task_items: [],
            task_headers: [
                { text: 'Task', value: 'name', width: this.advanced_view ? '5em':'default'} ,
                { text: 'Status', value: 'status' },
                { text: 'Start', value: 'start' },
                { text: 'Stop', value: 'end' },
                { text: 'Duration', value: 'duration_mins', align: 'right', sortable: false },
                { text: 'Credits', value: 'credits_consumed', align: 'right', sortable: false },
                { text: 'RAM', value: 'peak_memory', align: 'right', sortable: false, width: this.advanced_view ? '5em':'default' },
                { text: 'Actions', value: 'actions', sortable: false , align: 'center'}
            ],
            task_headers_mobile: [
                { text: 'Task', value: 'name', width: this.advanced_view ? '5em':'default'} ,
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            task_pagination: {
                page: 1,
                itemsPerPage: 50
            },
            tasks_tout: null,
            log_loading: false,
            selected_task: null,
            show_task_log: false,
            task_logs_tout: null
        }
    },
    methods: {
        load_page(page){
            this.page = page;
            this._loadJobDetails();
        },
        loadJobDetails(){
            clearInterval(this.tasks_tout);
            this._loadJobDetails();
            this.tasks_loading = true;
            this.task_items = [];
            let my = this;
            this.tasks_tout = setInterval(function (){
                my._loadJobDetails();
            }, 30000)
        },
        _loadJobDetails() {
            axios.get(`https://${this.$buyerAPI}/projects/${this.job_details_obj.group_id || this.job_details_obj.project_id}/jobs/${this.job_details_obj.id}`)
            .then(resp => {
                let job_details = (resp.data && resp.data.data) || {};
                this.update_job_details_obj(job_details);
                this.tasks_loading = false;
                if (this.mobile_view){
                    let start_index = (this.page - 1) * this.total_visible;
                    let end_index = start_index + this.total_visible;
                    this.task_items = job_details.tasks.slice(start_index, end_index);
                    this.page_length = Math.round(Math.ceil(job_details.tasks.length/50));
                }else{
                    this.task_items = job_details.tasks || [];
                }
            })
        },
        getTaskLogs(task, redshift){
            clearInterval(this.task_logs_tout);
            this.selected_task = task;
            this.task_log = null;
            this.show_task_log = true;
            this.log_loading = true;
            this.task_log_url = `https://${this.$buyerAPI}/projects/${this.job_details_obj.group_id}/jobs/${this.job_details_obj.id}/tasks/${this.selected_task.id}`;
            this.task_log_html = false;
            if (redshift){
                this.task_log_url += `?redshift_log=1`;
            }
            this._getTaskLogs(redshift);
            var my = this;
            this.task_logs_tout = setInterval(function(){
                my._getTaskLogs(redshift);
            }, 30000)
        },
        _getTaskLogs(redshift){      
            axios.get(this.task_log_url)
            .then(resp => {
                this.task_log = resp.data.data;
                this.log_loading = false;
                if (redshift){
                    this.task_log_html = true;
                }
            })
        },
        _getRedshiftLogs() {
            this.getTaskLogs(this.selected_task, true);
        },
        _getAppLogs() {
            this.getTaskLogs(this.selected_task, false);
        },
        _populate_task_logs_iframe(){
            let redshift_iframe = this.$refs.redshift_iframe;
            let redshift_iframe_doc = redshift_iframe.contentDocument || redshift_iframe.contentWindow.document;
            redshift_iframe_doc.open();
            redshift_iframe_doc.write((this.task_log && this.task_log.log) || "Logs are empty");
            redshift_iframe_doc.close();
        },
        hide_task_logs(){
            this.show_task_log = false;
            this.log_loading = false;
            clearInterval(this.task_logs_tout);
        },
    },
    watch: {
        job_details_obj : {
            handler() {
                if (this.current_job_details_obj.id != this.job_details_obj.id){
                    this.current_job_details_obj = this.job_details_obj;
                    clearInterval(this.tasks_tout);
                    this.loadJobDetails();
                    this.avail_height = `${screen.availHeight - 150}px`;
                }
            }
        }
    },
    created() {
        this.current_job_details_obj = this.job_details_obj;
        this.avail_height = `${screen.availHeight - 150}px`;
        if (["xs", "sm"].indexOf(this.$vuetify.breakpoint.name) > -1){
            this.mobile_view = true;
        }
        this.loadJobDetails();
    },
    destroyed() {
        clearInterval(this.tasks_tout);
    }
}
</script>
